import React, { useState } from "react";
import { motion } from "framer-motion";
import "../GuidedTour.css";

export default function Step2_AddStudent({ onComplete, className }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!firstName.trim() || !lastName.trim()) {
      setError("Please enter both first and last name");
      return;
    }

    // Instant completion - no API call
    onComplete(firstName.trim(), lastName.trim());
  };

  return (
    <div className="tour-step-container">
      <motion.div
        className="tour-step-full-card"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        {/* Step Header */}
        <div className="tour-step-header">
          <div className="tour-step-icon-large">
            <i className="fa-solid fa-user-plus"></i>
          </div>
          <h2 className="tour-step-title">Enroll a Student</h2>
          <p className="tour-step-description">
            Now let's enroll a student to "<strong>{className}</strong>
            ".
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="tour-step-form">
          <div className="demo-form-row">
            <div className="demo-form-group">
              <label htmlFor="firstName">
                <i className="fa-solid fa-user"></i>
                First Name
                <span className="required">*</span>
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                className="demo-input"
                autoFocus
              />
            </div>

            <div className="demo-form-group">
              <label htmlFor="lastName">
                <i className="fa-solid fa-user"></i>
                Last Name
                <span className="required">*</span>
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                className="demo-input"
              />
            </div>
          </div>
          {/* Error Message */}
          {error && (
            <div className="demo-error">
              <i className="fa-solid fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          {/* Submit Button */}
          <div className="demo-form-actions">
            <button type="submit" className="demo-submit-btn">
              <i className="fa-solid fa-circle-chevron-right"></i>
              Next
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
